module.exports = function (baseApi) {
  return {
    "apiEndpoints": {
      "marketing": {
        "addNewsletter": "newsletter-signup",
        "addNewsletterv2": "newsletter-sms-signup",
        "address": "account-addresses",
        "account": "account",
        "refund-receipt-email": "refund-receipt-email",
        "getSaleforceContactId": "get-sfsc-person-contact-id",
        "payInAppReceipt": "pay-in-app-receipt"
      },
      "guest-relations": {
        "createContactUsTicket": "contact-us-ticket"
      },
      "location": {
        "geoip": "geoip",
        "locatorsearch": "locatorsearch",
        "zipcode": "zipsearch",
        "vendorsearch": "vendorsearch"
      },
      "ups": {
        "validate-address": "validate-address"
      },
      "dinetime": {
        "addWaitlist": "site/{siteId}/webahead",
        "updateWaitlist": "site/{siteId}/webahead/{visitId}",
        "getWaitlistStatus": "site/{siteId}/webahead/status",
        "getWaitlistStatusByVisit": "site/{siteId}/webahead/{visitId}",
        "cancelWaitlistVisit": "site/{siteId}/webahead/{visitId}/cancel",
        "checkInWaitList": "webahead/{confirmationNumber}/checkin"
      },
      "sitecore-services": {
        "giftCardBalance": "giftcardbalance"
      },
      "apple-pay-services": {
        "validate": "validate"
      },
      "aad-b2c-utility-api": {
        "deleteUser": "user/{userId}"
      },
      "token-ex-api": {
        "getAuthToken": 'GetAuthToken/iframe'
      }
    }
  };
};